import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取预约类型列表
 * @param {*} params 
 */
export function getAppointmenttypes(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/appointmenttype/appointmenttypes',
        method: 'get',
        params: param
    })
}

/**
 * 删除指定id的预约类型
 * @param {*} id 
 */
export function deleteAppointmenttype(id) {
    return request({
        url: '/api/manager/appointmenttype/'+id,
        method: 'delete'
    })
}

/**
 * 添加预约类型
 * @param {}} param 
 */
export function addAppointmenttype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/appointmenttype',
        method: 'post',
        data: data
    })
}

/**
 * 修改预约类型
 * @param {}} param 
 */
export function editAppointmenttype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/appointmenttype',
        method: 'put',
        data: data
    })
}